// @core/stores/booking/BookingStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  BookingLifecycleResponse,
  CancelBookingRequest,
  CheckBookingAvailabilityRequest,
  CheckBookingAvailabilityResponse,
  CompleteBookingRequest,
  ConfirmBookingRequest,
  ListBookingScheduleResponse,
  MarkNoShowRequest,
  RejectBookingRequest,
  RescheduleBookingRequest,
  StartBookingRequest,
} from '@core/types/booking';

class BookingStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Cancel booking
   */
  async CancelBooking(target_type: string, target_id: string, data: CancelBookingRequest): Promise<BookingLifecycleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.CancelBooking(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Check booking availability
   */
  async CheckBookingAvailability(target_type: string, data: CheckBookingAvailabilityRequest): Promise<CheckBookingAvailabilityResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.CheckBookingAvailability(target_type, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Complete booking
   */
  async CompleteBooking(target_type: string, target_id: string, data: CompleteBookingRequest): Promise<BookingLifecycleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.CompleteBooking(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Confirm booking
   */
  async ConfirmBooking(target_type: string, target_id: string, data: ConfirmBookingRequest): Promise<BookingLifecycleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ConfirmBooking(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List booking schedule
   */
  async ListBookingSchedule(target_type: string, params?: { cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; sort?: string | number | boolean; time_max?: string | number | boolean; time_min?: string | number | boolean; }): Promise<ListBookingScheduleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ListBookingSchedule(target_type, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Mark no-show
   */
  async MarkNoShow(target_type: string, target_id: string, data: MarkNoShowRequest): Promise<BookingLifecycleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.MarkNoShow(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Reject booking
   */
  async RejectBooking(target_type: string, target_id: string, data: RejectBookingRequest): Promise<BookingLifecycleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.RejectBooking(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Reschedule booking
   */
  async RescheduleBooking(target_type: string, target_id: string, data: RescheduleBookingRequest): Promise<BookingLifecycleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.RescheduleBooking(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Start booking
   */
  async StartBooking(target_type: string, target_id: string, data: StartBookingRequest): Promise<BookingLifecycleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.StartBooking(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingStore = new BookingStore();
